import { PaginationActionProps } from 'common/state/types';

// #region AccountTransfer
export enum AccountTransferStatuses {
  REQUESTED = 'requested',
  TRANSFERED = 'transfered',
  CANCELLED = 'cancelled',
}

export interface AccountTransfer {
  account: string;
  amount: string;
  currency: string;
  date: string;
  id: number;
  requester: string;
  status: AccountTransferStatuses;
  url: string;
  wallet: string;
}

interface AccountTransfersStarted {
  type: 'accounts/transfers/started';
}

interface AccountTransfersFinished extends PaginationActionProps {
  type: 'accounts/transfers/finished';
  transfers?: AccountTransfer[];
  error?: string;
}

export type AccountTransfersActions =
  | AccountTransfersStarted
  | AccountTransfersFinished;

export interface NewAccountTransferStarted {
  type: 'accounts/transfers/new/started';
}

export interface NewAccountTransferFinished {
  type: 'accounts/transfers/new/finished';
  success: boolean;
  error?: string;
}

export interface AcceptAccountTransferStarted {
  type: 'accounts/transfers/accept/started';
}

export interface AcceptAccountTransferFinished {
  type: 'accounts/transfers/accept/finished';
  success: boolean;
  error?: string;
}

export interface DeclineAccountTransferStarted {
  type: 'accounts/transfers/decline/started';
}

export interface DeclineAccountTransferFinished {
  type: 'accounts/transfers/decline/finished';
  success: boolean;
  error?: string;
}

export type NewAccountTransferActions =
  | NewAccountTransferStarted
  | NewAccountTransferFinished;

export type AcceptAccountTransferActions =
  | AcceptAccountTransferStarted
  | AcceptAccountTransferFinished;

export type DeclineAccountTransferActions =
  | DeclineAccountTransferStarted
  | DeclineAccountTransferFinished;
// #endregion
